export enum DataType {
  Task = 'task',
  Goal = 'goal',
  LifeArea = 'life-area',
}

export enum InteractionType {
  Task = 'task',
}
